const actions = {
    selectTab({ commit }, params) {
        if (params.type === 'audiences') commit('ui/monitoring/setActiveTab', { tab: params.tab }, { root: true })
        else if (params.type === 'jobs') commit('ui/dataEntry/setActiveTab', { tab: params.tab }, { root: true })
        else if (params.type === 'cclones') commit('ui/cclone/setActiveTab', { tab: params.tab }, { root: true })
    }
}

export default actions
